import React from 'react';
import { IconComponentProps } from 'src/icons/types';

export const DropdownIcon = (props: IconComponentProps) => (
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M4 6L8 10L12 6H4Z" fill="currentColor" />
  </svg>
);
